import { useState, useContext } from 'react';
import { HiEyeOff, HiEye } from 'react-icons/hi';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { AuthContext } from '../ContextAuth/Context';
import { toast } from 'react-toastify';

function Signin() {
  const [inputs, setInputs] = useState({ username: '', password: '' });
  const [passwordShown, setPasswordShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const contextConsume = useContext(AuthContext);
  const { setUserToken } = contextConsume;
  const navigate = useNavigate();

  const handleChange = (e) => {
    const target = e.target;
    const { value, name } = target;
    setInputs((input) => ({
      ...input,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/login`,
        {
          email: inputs.username,
          password: inputs.password,
        }
      );

      if (response.data.status === 'success') {
        navigate('/otppage', { replace: true, state: { otpType: 'Login' } });
        setUserToken(response.data.token);
        sessionStorage.setItem('user', JSON.stringify(response.data));
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNavigateToSignUp = () => {
    navigate('/signup');
  };

  const handleNavigateToEmailValidation = () => {
    return navigate('/emailvalidation');
  };

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  return (
    <div className='w-full bg-p-wh flex items-center flex-col gap-8 rounded-lg mx-auto font-pin pt-28 px-6 max-w-lg'>
      <div className='font-pin text-center'>
        <h1 className='text-2xl  font-semibold text-p-pin pb-2'>Login</h1>
        <p>
          Don't have an account?{' '}
          <span
            className='text-b-mc font-semibold cursor-pointer hover:text-b-mc/75'
            onClick={handleNavigateToSignUp}
          >
            Sign Up
          </span>
        </p>
      </div>
      <form
        className='flex items-center flex-col gap-4 w-full box-border'
        onSubmit={handleSubmit}
      >
        <div className='flex flex-col gap-2 w-full'>
          <label className='text-p-bk text-base font-pin'>
            Username<sup className='text-red-500'>*</sup>
          </label>
          <input
            type='text'
            className='focus:outline-none focus:ring focus:b-mc border-2 w-full h-14 rounded-md border-t-bk px-4'
            name='username'
            value={inputs.username}
            onChange={handleChange}
            required
          />
        </div>

        <div className='flex flex-col gap-2 w-full relative'>
          <label className='text-p-bk text-base font-pin'>
            Password<sup className='text-red-500'>*</sup>
          </label>
          <input
            type={passwordShown ? 'text' : 'password'}
            className='focus:outline-none focus:ring focus:b-mc relative border-2 w-full h-14 rounded-md border-t-bk px-4'
            name='password'
            value={inputs.password}
            onChange={handleChange}
            aria-required
          />
          {passwordShown ? (
            <HiEye
              className='absolute bottom-[46px] right-6 cursor-pointer'
              onClick={togglePassword}
            />
          ) : (
            <HiEyeOff
              className='absolute bottom-[46px] right-6 text-s-bk cursor-pointer'
              onClick={togglePassword}
            />
          )}

          <p
            className='text-b-mc w-full flex justify-end cursor-pointer hover:text-b-mc/75'
            onClick={handleNavigateToEmailValidation}
          >
            Forgot password?
          </p>
        </div>

        <button
          className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-4 py-3 w-full my-4 font-semibold disabled:bg-b-mct bg-b-mc rounded-md relative'
          disabled={isLoading}
        >
          Login
          {isLoading ? (
            <ReactLoading
              type='cylon'
              color='#5AC8FA'
              height={44}
              width={44}
              className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
            />
          ) : null}
        </button>
      </form>
    </div>
  );
}
export default Signin;
